import Hero from "@/sections/Hero";
import AboutSection from "@/sections/AboutSection";
import FounderSection from "@/sections/FounderSection";
import ServicesSection from "@/sections/ServicesSection";
import IndustriesSection from "@/sections/IndustriesSection";
import WhyChoose from "@/sections/WhyChoose";
import FeaturedProjects from "@/sections/FeaturedProjects";
import HospitalityRetail from "@/sections/HospitalityRetail";
import ArtCulture from "@/sections/ArtCulture";
import ProcessTimeline from "@/sections/ProcessTimeline";
import PartnersMarquee from "@/sections/PartnersMarquee";
import Testimonials from "@/sections/Testimonials";
import CTASection from "@/sections/CTASection";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <AboutSection />
      <FounderSection />
      <ServicesSection />
      <IndustriesSection />
      <WhyChoose />
      <FeaturedProjects />
      <HospitalityRetail />
      <ArtCulture />
      <ProcessTimeline />
      <PartnersMarquee />
      <Testimonials />
      <CTASection />
    </div>
  );
}
